'use client';

import { cn } from '@baseball-near-you/ui';
import { isServer } from '@tanstack/react-query';
import { siteNoticeLocalStorageKey } from '../SiteNotice';
import { EmailSubscriptionForm } from './EmailSubscriptionForm';

export function EmailSubscription(props: { className?: string }) {
  return (
    <div
      className={cn(
        'h-min w-full md:sticky md:w-1/4',
        isServer
          ? false
          : localStorage.getItem(siteNoticeLocalStorageKey) === '1'
            ? 'md:top-[6rem]'
            : 'md:top-[8rem]'
      )}
    >
      <div className={cn('flex-col rounded-md bg-red p-4', props.className)}>
        <h3 className="font-bold! text-white!">Join the club!</h3>
        <h4 className="font-normal! text-sm! text-white/75!">
          Sign up for our newsletter for more articles like this and features
          updates from our team!
        </h4>
        <div className="mt-2 w-full">
          <EmailSubscriptionForm />
        </div>
      </div>
    </div>
  );
}
